module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-12-zoom.a8d657fd.png";